import React from 'react';
import type { IconProps } from '../icons/generated';
import type { BannerProps as BannerNewProps, BannerStatus } from './Banner';

export type BannerKind = BannerStatus;

export interface OldBannerProps extends Omit<BannerNewProps, 'hasIcon'> {
  /** @deprecated status를 대신 사용해주세요. */
  kind?: BannerKind;
  /** @deprecated leftIcon을 대신 사용해주세요. */
  iconComponent?: React.ComponentType<IconProps>;
  /** @deprecated closable을 대신 사용해주세요. */
  closeButton?: boolean;
  /** @deprecated hasIcon을 대신 사용해주세요. */
  showIcon?: boolean;
}

export function convertOldBannerProps(props: OldBannerProps): BannerNewProps {
  const { kind, status, iconComponent: IconComponent, leftIcon, closeButton, closable, showIcon, ...restProps } = props;

  return {
    ...restProps,
    status: status ?? kind,
    leftIcon: leftIcon ?? (IconComponent ? React.createElement(IconComponent) : undefined),
    closable: closable ?? closeButton,
    hasIcon: showIcon,
  };
}
